import React, { useEffect, useState, useMemo, memo, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, StepConnector, stepConnectorClasses, Stepper, Step, StepLabel, useTheme, IconButton, TextField, InputAdornment, MenuItem, Select, FormControl, useMediaQuery, Dialog, DialogContent, DialogActions } from '@mui/material';
import { styled } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { useNavigate } from 'react-router-dom';
import { getCommercialMarketing } from '../../../redux/slice/Commercialmarketing.slice';
import { getUsers } from '../../../redux/slice/users.slice';
import { useDispatch, useSelector } from 'react-redux';
import { getDealers } from '../../../redux/slice/dealer.slice';
import { deleteLiasoning, editLiasoning, getLiasoning } from '../../../redux/slice/liasoning.slice';
import Header from '../../../components/Header';
import { tokens } from '../../../theme';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';

import { deletePurchase, getPurchase } from '../../../redux/slice/Purchase.slice';

import { format } from 'date-fns';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
import PrintIcon from '@mui/icons-material/Print';
import { Image_URL } from '../../../utils/baseURL';
import { getstore } from '../../../redux/slice/store.slice';
import pdfFonts from "pdfmake/build/vfs_fonts";

import pdfMake from "pdfmake/build/pdfmake";
import LexendBold from "../../../fonts/Lexend-Bold.ttf";
import LexendRegular from "../../../fonts/Lexend-Regular.ttf";
pdfMake.vfs = pdfFonts.pdfMake.vfs; // Use default vfs as a base

const getLexendFonts = async () => {
    const fetchFont = async (fontPath) => {
        const response = await fetch(fontPath);
        const buffer = await response.arrayBuffer();
        return bufferToBase64(buffer);
    };

    const regularFont = await fetchFont(LexendRegular);
    const boldFont = await fetchFont(LexendBold);

    pdfMake.vfs['Lexend-Regular.ttf'] = regularFont;
    pdfMake.vfs['Lexend-Bold.ttf'] = boldFont;

    pdfMake.fonts = {
        Lexend: {
            normal: 'Lexend-Regular.ttf',
            bold: 'Lexend-Bold.ttf',
        },
    };
};

const bufferToBase64 = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
};

const getBase64Image = (img) => {
    return new Promise((resolve) => {
        const canvas = document.createElement("canvas");
        const image = new Image();
        image.crossOrigin = "anonymous";
        image.onload = () => {
            canvas.width = image.width;
            canvas.height = image.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0);
            const dataURL = canvas.toDataURL("image/png");
            resolve(dataURL);
        };
        image.src = img;
    });
};

// import stamp from '../../../../public/assets/images/stamp/stamp.png'

const ColorlibConnector = styled(StepConnector)(({ theme }) => {
    const isVerySmallScreen = useMediaQuery('(max-width:425px)');
    const isMediumScreen = useMediaQuery('(min-width:426px) and (max-width:1024px)');

    return {
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: isVerySmallScreen ? 12 : (isMediumScreen ? 15 : 25),
            left: isVerySmallScreen ? 'calc(-50% + 12px)' : (isMediumScreen ? 'calc(-50% + 15px)' : 'calc(-50% + 25px)'),
            right: isVerySmallScreen ? 'calc(50% + 12px)' : (isMediumScreen ? 'calc(50% + 15px)' : 'calc(50% + 25px)'),
        },
        [`&.${stepConnectorClasses.active}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundImage: 'linear-gradient( 95deg,#134670 0%, #2B89D5 120%)',
            },
        },
        [`&.${stepConnectorClasses.completed}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundImage: 'linear-gradient( 95deg,#134670 0%, #2B89D5 120%)',
            },
        },
        [`& .${stepConnectorClasses.line}`]: {
            height: isVerySmallScreen ? 2 : 3,
            border: 0,
            backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#b9b9b9',
            borderRadius: 1,
        },
    };
});

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState, isMobile, isVerySmallScreen }) => ({
    backgroundColor: ownerState.completed ? '#134670' : '#fff',
    zIndex: 1,
    color: ownerState.completed ? '#fff' : '#000',
    width: isVerySmallScreen ? 30 : (isMobile ? 40 : 50),
    height: isVerySmallScreen ? 30 : (isMobile ? 40 : 50),
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
}));

function ColorlibStepIcon(props) {
    const { active, completed, className, icon } = props;
    const isVerySmallScreen = useMediaQuery('(max-width:425px)');
    const isMediumScreen = useMediaQuery('(min-width:426px) and (max-width:1024px)');

    const stepNumber = String(icon);

    return (
        <ColorlibStepIconRoot
            ownerState={{ completed, active }}
            className={className}
            isMobile={isVerySmallScreen || isMediumScreen}
            isVerySmallScreen={isVerySmallScreen}
        >
            <Typography
                variant={isVerySmallScreen ? "body2" : (isMediumScreen ? "body2" : "h4")}
                style={{ fontWeight: 'bold', color: completed ? '#fff' : '#000' }}
            >
                {stepNumber}
            </Typography>
        </ColorlibStepIconRoot>
    );
}

ColorlibStepIcon.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    completed: PropTypes.bool,
    icon: PropTypes.node,
    onClick: PropTypes.func,
};

const steps = ['Purchase Order(PO) Generate', 'Partially Payment', 'Payment to Vendor', 'Partially Material', 'Material Recieved at Store'];

const ListPurchase = () => {
    const isMobile = useMediaQuery('(max-width:1024px)');


    const [activeStep, setActiveStep] = React.useState(0);

    const [activeSteps, setActiveSteps] = React.useState({});
    const [filledSteps, setFilledSteps] = useState([]);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [itemFilledSteps, setItemFilledSteps] = useState({});

    const handleStep = (itemId, step) => {
        setActiveSteps((prev) => {
            const newSteps = { ...prev, [itemId]: step };
            for (let i = 0; i < step; i++) {
                newSteps[itemId] = i + 1;
            }
            return newSteps;
        });
    };

    const pur = useSelector(state => state.purchase.purchase);


    const getUnfilledFields = (purchaseData) => {
        const fields = [
            { name: 'SrNo', step: 0, label: 'Purchase Order(PO) Generate' },
            { name: '', step: 1, label: 'Partially Payment' },
            { name: '', step: 2, label: 'Payment to Vendor' },
            { name: '', step: 3, label: 'Partially Material' },
            { name: '', step: 4, label: 'Material Recieved at Store' },
        ];

        const unfilledFields = fields?.filter(field => !purchaseData[field.name]);
        const firstIncompleteStep = unfilledFields?.length > 0 ? unfilledFields[0].step : fields?.length;

        return { unfilledFields, firstIncompleteStep };
    };
    const handleEdit = (id) => {
        const purchaseData = purchase?.find((v) => v._id === id);
        if (purchaseData) {
            const { unfilledFields, firstIncompleteStep } = getUnfilledFields(purchaseData);
            navigate('/admin/add-purchase', {
                state: {
                    ...purchaseData,
                    unfilledFields,
                    activeStep: firstIncompleteStep,
                    completedSteps: getCompletedSteps(purchaseData)
                }
            });
        }
    };
    const getPaymentStatus = (purchaseItem) => {
        // 
        const vendorPayment = purchaseItem.venderPayments?.find(p => p.VendorpurchaseId === purchaseItem._id);
        // 

        if (vendorPayment) {
            const totalPayment = vendorPayment.VendorPaymentDetails?.reduce((sum, detail) => sum + Number(detail.VendorPaymentTotal), 0);
            // 
            if (totalPayment === purchaseItem.amountTotal) {
                return 'full';
            } else if (totalPayment > 0) {
                return 'partial';
            }
        }
        return 'none';
    };

    const getCompletedSteps = (purchaseItem) => {

        if (!purchaseItem) {

            return 0;
        }

        // 

        let stepStatus = {
            1: true,
            2: false,
            3: false,
            4: false,
            5: false
        };

        const paymentStatus = getPaymentStatus(purchaseItem);
        // 

        if (paymentStatus === 'full') {
            stepStatus[2] = true;
            stepStatus[3] = true;
        } else if (paymentStatus === 'partial') {
            stepStatus[2] = true;
        }

        // 

        const storeData = purchaseItem.purchaseDetails?.find(v => v.purchase === purchaseItem._id);
        // 

        if (storeData) {
            let allItemsReceived = true;
            let someItemsReceived = false;

            purchaseItem.multipledata.forEach(purchaseProduct => {
                const storeProduct = storeData.multipleQty?.find(sp => sp.productName === purchaseProduct.productName);
                // 

                if (storeProduct) {
                    const receivedQty = Number(storeProduct.recieveQtyforstore);
                    const orderedQty = Number(purchaseProduct.Qty);


                    if (receivedQty === orderedQty) {
                        someItemsReceived = true;
                    } else if (receivedQty < orderedQty) {
                        allItemsReceived = false;
                        someItemsReceived = true;
                    }
                } else {
                    allItemsReceived = false;
                }
            });



            if (allItemsReceived) {
                stepStatus[5] = true;
                stepStatus[4] = true;

            }
            if (someItemsReceived) {
                stepStatus[4] = true;
            }
        }

        // 
        return stepStatus;
    };

    useEffect(() => {
        setActiveSteps({ ...activeSteps });
    }, []);


    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [searchTerm, setSearchTerm] = useState('');
    const [filterOption, setFilterOption] = useState('all');
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };
    const handleFilterChange = (event) => {
        setFilterOption(event.target.value);
    };

    useEffect(() => {
        const initialSteps = {};
        const initialFilledSteps = {};
        purchase.forEach(item => {
            initialSteps[item._id] = item.completedSteps || 0;
            initialFilledSteps[item._id] = item.filledSteps || [];
        });
        setActiveSteps(initialSteps);
        setItemFilledSteps(initialFilledSteps);
    }, []);

    const MobileStepper = ({ steps, activeStep, completedSteps }) => {
        const isVerySmallScreen = useMediaQuery('(max-width:425px)');
        const isMediumScreen = useMediaQuery('(min-width:426px) and (max-width:1024px)');

        if (isVerySmallScreen) {
            const firstRowSteps = steps.slice(0, 3);
            const secondRowSteps = steps.slice(3, 5);

            const renderStepper = (stepArray, startIndex) => (
                <Stepper alternativeLabel activeStep={activeStep - startIndex} connector={<ColorlibConnector />}>
                    {stepArray.map((label, index) => {
                        const stepNumber = index + 1 + startIndex;
                        const isStepCompleted = completedSteps[stepNumber];
                        return (
                            <Step key={label} completed={isStepCompleted}>
                                <StepLabel
                                    StepIconComponent={ColorlibStepIcon}
                                    StepIconProps={{
                                        completed: isStepCompleted,
                                        icon: stepNumber
                                    }}
                                >
                                    <Typography style={{
                                        color: isStepCompleted ? theme.palette.mode === 'dark' ? '#6da2cd' : "#165e99" : theme.palette.text.primary,
                                        fontWeight: '600'
                                    }}>
                                        {label}
                                    </Typography>
                                </StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
            );

            return (
                <Box>
                    {renderStepper(firstRowSteps, 0)}
                    <Box sx={{ my: 1 }} />
                    {renderStepper(secondRowSteps, 3)}
                    <Box sx={{ my: 1 }} />
                </Box>
            );
        } else if (isMediumScreen) {
            const firstRowSteps = steps.slice(0, 5);

            const renderStepper = (stepArray, startIndex) => (
                <Stepper alternativeLabel activeStep={activeStep - startIndex} connector={<ColorlibConnector />}>
                    {stepArray.map((label, index) => {
                        const stepNumber = index + 1 + startIndex;
                        const isStepCompleted = completedSteps[stepNumber];
                        return (
                            <Step key={label} completed={isStepCompleted}>
                                <StepLabel
                                    StepIconComponent={ColorlibStepIcon}
                                    StepIconProps={{
                                        completed: isStepCompleted,
                                        icon: stepNumber
                                    }}
                                >
                                    <Typography style={{
                                        color: isStepCompleted ? theme.palette.mode === 'dark' ? '#6da2cd' : "#165e99" : theme.palette.text.primary,
                                        fontWeight: '600'
                                    }}>
                                        {label}
                                    </Typography>
                                </StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
            );

            return (
                <Box>
                    {renderStepper(firstRowSteps, 0)}
                    <Box sx={{ my: 1 }} />
                </Box>
            );
        }

        return null;
    };

    const handleAddMarketing = () => {
        navigate('/admin/add-purchase');
    }

    const purchase = useSelector(state => state.purchase.purchase);
    const AllvendorPayment = useSelector(state => state.vendorPayment.VendorPayment)
    const isMobileee = useMediaQuery('(max-width:500px)');



    useEffect(() => {
        dispatch(getPurchase());
        dispatch(getstore())
    }, [dispatch]);

    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [deleteMarketing, setDeleteMarketing] = useState(null);

    const handleDelete = (id) => {
        setDeleteMarketing(id);
        setDeleteConfirmOpen(true);
    };

    const confirmDelete = () => {
        if (deleteMarketing) {
            dispatch(deletePurchase(deleteMarketing)).then(() => {
                dispatch(getPurchase());
            });
            setDeleteConfirmOpen(false);
            setDeleteMarketing(null);
        }
    }

    const cancelDelete = () => {
        setDeleteConfirmOpen(false);
        setDeleteMarketing(null);
    }

    const productData = useSelector(state => state.products.products.products);
    const vendors = useSelector(state => state.vendors.vendors);
    const terms = useSelector(state => state.Terms.Terms);
    const warehouses = useSelector(state => state.warehouses.warehouses);
    const store = useSelector(state => state.store.Store)
    const [statusFilter, setStatusFilter] = useState('all'); // Add this state
    const handleStatusChange = (event) => {
        setStatusFilter(event.target.value);
    };

    const filteredPurchases = purchase?.filter(v => {
        if (statusFilter !== 'all') {
            const paymentPercentage = ((Number(v.venderPayments?.find(d => d.VendorpurchaseId === v._id)?.VendorPaymentDetails.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0) * 100) / v.amountTotal || 0;
            const materialPercentage = (v.purchaseDetails?.reduce((acc, curr) => acc + curr.multipleQty.reduce((sum, item) => sum + Number(item.recieveQtyforstore), 0), 0) * 100) / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1);
            if (statusFilter === 'pending' && (Math.round(paymentPercentage) >= 100 && materialPercentage >= 100)) {
                return false;
            }
            if (statusFilter === 'complete' && (Math.round(paymentPercentage) < 100 || materialPercentage < 100)) {
                return false;
            }
        }
        const searchTermLower = searchTerm.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
        const includesSearchTerm = (value) => {
            if (value == null) return false;
            const normalizedValue = value.toString().toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
            return normalizedValue.includes(searchTermLower);
        };

        const paymentPercentage = (() => {
            const vendorPayment = v.venderPayments?.[0];
            if (vendorPayment) {
                const totalPayment = vendorPayment?.VendorPaymentDetails.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0);
                return ((totalPayment * 100) / v.amountTotal).toFixed(2);
            }
            return '0';
        })();

        const materialReceivedPercentage = (() => {
            const relatedStoreEntries = v.purchaseDetails?.filter(s => s.purchase === v._id);
            const totalReceivedQty = relatedStoreEntries?.reduce((acc, curr) => {
                return acc + curr.multipleQty.reduce((sum, item) => sum + Number(item.recieveQtyforstore), 0);
            }, 0);
            const totalOrderedQty = v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1;
            return (totalReceivedQty * 100 / totalOrderedQty).toFixed(2);
        })();

        if (
            includesSearchTerm(v.SrNo) ||
            includesSearchTerm(v.PurchaseDate ? format(new Date(v.PurchaseDate), 'dd-MM-yyyy') : '') ||
            includesSearchTerm(v.amountTotal) ||
            includesSearchTerm(v.taxableAmount) ||
            includesSearchTerm(v.totalGstAmount) ||
            includesSearchTerm(paymentPercentage) ||
            includesSearchTerm(materialReceivedPercentage)
        ) {
            return true;
        }

        const vendor = vendors?.find(vendor => vendor._id === v.vendor);
        if (
            vendor &&
            (includesSearchTerm(vendor.businessName) ||
                includesSearchTerm(vendor.officeAddress) ||
                vendor.contactPersonalDetails.some(contact =>
                    includesSearchTerm(contact.contactPersonName) ||
                    includesSearchTerm(contact.contactNumber)
                )) ||
            v.vendorDetails.some(vendorDetail => includesSearchTerm(vendorDetail.businessName))
        ) {
            return true;
        }

        // Check warehouse details
        const warehouse = warehouses?.find(w => w._id === v.werehouse);
        if (
            warehouse &&
            (includesSearchTerm(warehouse.wareHouseName) ||
                includesSearchTerm(warehouse.address) ||
                includesSearchTerm(warehouse.contactPersonName) ||
                includesSearchTerm(warehouse.contactNumber)) ||
            v.wareHouseDetails.some(warehouseDetail => includesSearchTerm(warehouseDetail.wareHouseName))

        ) {
            return true;
        }

        // Check product details in multipledata
        return v.multipledata?.some(data => {
            const product = productData?.find(p => p._id === data.productName);
            return (
                product &&
                (includesSearchTerm(product.productName) ||
                    includesSearchTerm(product.Desacription) ||
                    includesSearchTerm(product.HSNcode)) ||
                includesSearchTerm(data.unitPrice) ||
                includesSearchTerm(data.Qty) ||
                includesSearchTerm(data.gst) ||
                includesSearchTerm(data.total) ||
                includesSearchTerm(data.gstAmount)
            );
        });
    });

    const getCurrentDate = () => {
        return format(new Date(), 'dd-MM-yyyy');
    };

    const formatCurrency = (value) => {
        if (typeof value === 'number') {
            return value.toFixed(2);
        }
        return '0.00';
    };

    const orderDetails = {
        billTo: {
            companyName: 'Tvarit Energy LLP.',
            address: '707 - Twin Star, North Block, Near Nana Mauva Circle, 150 Ft. Ring Road, Rajkot, Gujarat - 360005',
            gst: '24AAQFT9592E1ZK',
            contactNumber: '+91 97245 71843',
            email: 'info@tvaritenergy.in',
            website: 'www.tvaritenergy.in',
        },
    };

    const [openDialog, setOpenDialog] = useState(false);
    const [storeFile, setstoreFile] = useState(false);
    const [selectedPurchase, setSelectedPurchase] = useState(null);
    const imgUrl = Image_URL;
    // 

    const printRef = useRef();

    const handlePrint = (id) => {
        const purchaseData = purchase?.find((v) => v._id === id);
        setSelectedPurchase(purchaseData);
        setOpenDialog(true);
    };

    const handlestore = (id) => {
        const purchaseData = purchase?.find((v) => v._id === id);
        setSelectedPurchase(purchaseData);
        setstoreFile(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setstoreFile(false);
        setSelectedPurchase(null);
    };

    // const generatePrintContent = () => {
    //     const printContent = document.createElement('div');
    //     printContent.innerHTML = printRef.current.innerHTML;
    //     printContent.style.color = '#1A2B4F';
    //     printContent.style.backgroundColor = 'white';
    //     printContent.style.padding = '20px';
    //     printContent.style.width = '100%'; // Ensure full width
    //     printContent.style.boxSizing = 'border-box'; // Include padding in width calculation

    //     const purchaseOrderElement = printContent.querySelector('.purchase-order-title');
    //     if (purchaseOrderElement) {
    //         purchaseOrderElement.style.color = '#1A2B4F';
    //     }

    //     const logoElement = printContent.querySelector('.pdf-logo');
    //     if (logoElement) {
    //         logoElement.src = '../../assets/images/logo/logo.svg';
    //     }

    //     const tables = printContent.querySelectorAll('table');
    //     tables.forEach(table => {
    //         table.style.backgroundColor = 'white';
    //     });

    //     const tableHeaders = printContent.querySelectorAll('td');
    //     tableHeaders.forEach(header => {
    //         header.style.backgroundColor = 'white';
    //         header.style.color = '#1A2B4F';
    //     });

    //     const typographyElements = printContent.querySelectorAll('Typography');
    //     typographyElements.forEach(element => {
    //         element.style.color = '#1A2B4F';
    //     });

    //     return printContent;
    // };

    // const downloadPDF = () => {
    //     const printContent = generatePrintContent();
    //     document.body.appendChild(printContent);

    //     html2canvas(printContent, {
    //         scale: 2,
    //         backgroundColor: '#ffffff',
    //         logging: true,
    //         onclone: (clonedDoc) => {
    //             clonedDoc.body.style.width = '210mm';
    //             clonedDoc.body.style.height = '297mm';
    //             const logoElement = printContent.querySelector('.pdf-logo');
    //             if (logoElement) {
    //                 logoElement.src = '../../assets/images/logo/logo.svg';
    //             }
    //         }
    //     }).then((canvas) => {
    //         const imgData = canvas.toDataURL('image/JPEG', 0.2);
    //         const pdf = new jsPDF('p', 'mm', 'a4');
    //         const imgWidth = 210 - 20;
    //         const pageHeight = pdf.internal.pageSize.height;
    //         const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //         let heightLeft = imgHeight;

    //         let position = 10;

    //         pdf.addImage(imgData, 'JPEG', 10, position, imgWidth, imgHeight);
    //         heightLeft -= pageHeight;

    //         while (heightLeft >= 0) {
    //             position = heightLeft - imgHeight;
    //             pdf.addPage();
    //             pdf.addImage(imgData, 'JPEG', 10, position, imgWidth, imgHeight);
    //             heightLeft -= pageHeight;
    //         }

    //         const pdfFilename = `${(selectedPurchase?.vendorDetails)?.map(v => v.businessName).join('_') || 'N/A'}_${selectedPurchase?.PurchaseDate ? format(new Date(selectedPurchase.PurchaseDate), 'dd-MM-yyyy') : 'N/A'}_${selectedPurchase?.SrNo ? selectedPurchase.SrNo.slice(-4) : 'N/A'}.pdf`;
    //         pdf.save(pdfFilename);
    //     }).catch(err => {
    //         console.error('Error generating PDF:', err);
    //     }).finally(() => {
    //         // Always remove the temporary element from the actual document
    //         if (document.body.contains(printContent)) {
    //             document.body.removeChild(printContent);
    //         }
    //     });
    // };
    const generateProductRows = (processItem) => {
        return processItem.map((item, index) => {
            const matchedItem = selectedPurchase?.multipledata?.find(
                p => p.productName === item._id
            );

            const ShowDescription = matchedItem?.description || 'N/A';
            const qty = matchedItem?.Qty ?? 'N/A';
            const unitPrice = matchedItem?.unitPrice ?? 'N/A';
            const total =
                matchedItem?.Qty && matchedItem?.unitPrice
                    ? matchedItem.Qty * matchedItem.unitPrice
                    : 'N/A';

            return [
                { text: (index + 1).toString(), fontSize: 9 },
                { text: item?.productName || 'N/A', fontSize: 9 },
                { text: ShowDescription, fontSize: 9 },
                { text: item?.HSNcode || 'N/A', fontSize: 9 },

                // 👇 match your header structure
                { text: qty.toString(), fontSize: 9 },
                { text: ShowDescription, fontSize: 9 }, // duplicate column (as per header)
                { text: qty.toString(), fontSize: 9 },
                { text: unitPrice !== 'N/A' ? `Rs. ${unitPrice}` : 'N/A', fontSize: 9 },
                { text: total !== 'N/A' ? `Rs. ${total}` : 'N/A', fontSize: 9 },
            ];
        });
    };

    const generatePdfContent = async () => {


        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        pdfMake.fonts = {
            Lexend: {
                normal: 'Lexend-Regular.ttf',
                bold: 'Lexend-Bold.ttf',
            }
        };

        const logoSrc = theme.palette.mode === "dark" ? '../../assets/images/logo/logo.svg' : '../../assets/images/logo/logo.svg';
        const logoBase64 = await getBase64Image(logoSrc);
        const stampImg = await getBase64Image("../../assets/images/stamp/stamp.svg")
        const allPagesContent = [];


        allPagesContent.push(
            {
                columns: [
                    {
                        image: logoBase64,
                        width: 100,
                        margin: [0, 0, 0, 0]
                    },
                    {
                        text: 'PURCHASE ORDER',
                        style: 'header',
                        alignment: 'right',
                        margin: [0, 0, 0, 2],
                        decoration: 'underline',
                        decorationColor: '#FB9822',
                        fontSize: 16,
                        characterSpacing: 2
                    },

                ],
            },
            {

                columns: [
                    {
                        width: '48%',
                        table: {
                            widths: ['100%'],
                            body: [
                                [{
                                    fillColor: '#1A2B4F',
                                    color: '#FFFFFF',
                                    text: 'BILL TO',
                                    bold: true,
                                    fontSize: 11,
                                    margin: [5, 5],
                                    characterSpacing: 2
                                }]
                            ]
                        }
                    },

                    { width: '4%', text: '' },
                    {
                        width: '48%',
                        table: {
                            widths: ['32%', '2%', '66%'],
                            body: [
                                [
                                    { text: 'PO # ', bold: true, fontSize: 9, border: [false, false, false, false] },
                                    { text: ':', border: [false, false, false, false], fontSize: 9 },
                                    { text: selectedPurchase?.SrNo || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                ],
                                [
                                    { text: 'Date', bold: true, fontSize: 9, border: [false, false, false, false] },
                                    { text: ':', border: [false, false, false, false], fontSize: 9 },
                                    { text: selectedPurchase?.PurchaseDate ? format(new Date(selectedPurchase.PurchaseDate), 'dd-MM-yyyy') : 'N/A', fontSize: 9, border: [false, false, false, false] }
                                ]
                            ]
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 0 : 0;
                            },
                            vLineWidth: function (i, node) {
                                return 0;
                            },
                        }
                    }
                ],
                margin: [0, 20, 0, 20]
            },
            {
                columns: [
                    {
                        width: '48%',
                        table: {
                            widths: ['42%', '2%', '56%'], // Changed widths
                            body: [
                                [
                                    { text: 'Company Name', border: [false, false, false, false], fontSize: 9 },
                                    { text: ':', border: [false, false, false, false], fontSize: 9 },
                                    { text: 'Tvarit Energy LLP.', fontSize: 9, border: [false, false, false, false] }
                                ],
                                [
                                    { text: 'Address', border: [false, false, false, false], fontSize: 9 },
                                    { text: ':', border: [false, false, false, false], fontSize: 9 },
                                    { text: '707 - Twin Star, North Block, Near Nana Mauva Circle, 150 Ft. Ring Road, Rajkot, Gujarat - 360005', fontSize: 9, border: [false, false, false, false] }
                                ],
                                [
                                    { text: 'GST No', border: [false, false, false, false], fontSize: 9 },
                                    { text: ':', border: [false, false, false, false], fontSize: 9 },
                                    { text: '24AAQFT9592E1ZK', fontSize: 9, border: [false, false, false, false] }
                                ],
                                [
                                    { text: 'Contact No', border: [false, false, false, false], fontSize: 9 },
                                    { text: ':', border: [false, false, false, false], fontSize: 9 },
                                    { text: '+91 97245 71843', fontSize: 9, border: [false, false, false, false] }
                                ],
                                [
                                    { text: 'Email', border: [false, false, false, false], fontSize: 9 },
                                    { text: ':', border: [false, false, false, false], fontSize: 9 },
                                    { text: 'info@tvaritenergy.in', fontSize: 9, border: [false, false, false, false] }
                                ],
                                [
                                    { text: 'Website', border: [false, false, false, false], fontSize: 9 },
                                    { text: ':', border: [false, false, false, false], fontSize: 9 },
                                    { text: 'www.tvaritenergy.in', fontSize: 9, border: [false, false, false, false] }
                                ]
                            ]
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 0 : 0;
                            },
                            vLineWidth: function (i, node) {
                                return 0;
                            },
                        }
                    }
                ]
            },
            {
                columns: [
                    {
                        width: '48%',
                        table: {
                            widths: ['100%'],
                            body: [
                                [{
                                    fillColor: '#1A2B4F',
                                    color: '#FFFFFF',
                                    text: 'VENDOR',
                                    bold: true,
                                    fontSize: 11,
                                    margin: [5, 5],
                                    characterSpacing: 2
                                }]
                            ]
                        }
                    },
                    { width: '4%', text: '' },
                    {
                        width: '48%',
                        table: {
                            widths: ['100%'],
                            body: [
                                [{
                                    fillColor: '#1A2B4F',
                                    color: '#FFFFFF',
                                    text: 'SHIP TO',
                                    bold: true,
                                    fontSize: 11,
                                    margin: [5, 5],
                                    characterSpacing: 2
                                }]
                            ]
                        }
                    }
                ],
                margin: [0, 20, 0, 20]
            },

            {
                columns: [
                    {
                        width: '48%',
                        stack: [
                            {
                                table: {
                                    widths: ['42%', '2%', '56%'],
                                    body: [
                                        [
                                            { text: 'Company Name', border: [false, false, false, false], fontSize: 9 },
                                            { text: ':', border: [false, false, false, false], fontSize: 9 },
                                            { text: (selectedPurchase?.vendorDetails)?.map(v => v.businessName) || 'N/A', border: [false, false, false, false], fontSize: 9 }
                                        ],
                                        [
                                            { text: 'Address', border: [false, false, false, false], fontSize: 9 },
                                            { text: ':', border: [false, false, false, false], fontSize: 9 },
                                            { text: (selectedPurchase?.vendorDetails)?.map(v => v.officeAddress) || 'N/A', border: [false, false, false, false], fontSize: 9 }
                                        ],
                                        [
                                            { text: 'Contact Person', border: [false, false, false, false], fontSize: 9 },
                                            { text: ':', border: [false, false, false, false], fontSize: 9 },
                                            { text: selectedPurchase?.vendorDetails?.map(v => v.contactPersonalDetails?.map(v => v.contactPersonName)).join(', ') || 'N/A', border: [false, false, false, false], fontSize: 9 }
                                        ],
                                        [
                                            { text: 'Contact No', border: [false, false, false, false], fontSize: 9 },
                                            { text: ':', border: [false, false, false, false], fontSize: 9 },
                                            { text: selectedPurchase?.vendorDetails?.map(v => v.contactPersonalDetails?.map(v => v.contactNumber)).join(', ') || 'N/A', border: [false, false, false, false], fontSize: 9 }
                                        ],

                                    ]
                                },
                                layout: {
                                    defaultBorder: false,
                                    paddingLeft: function (i) { return 4; },
                                    paddingRight: function (i) { return 4; },
                                    paddingTop: function (i) { return 4; },
                                    paddingBottom: function (i) { return 4; }
                                }
                            }
                        ]
                    },
                    { width: '4%', text: '' },
                    {
                        width: '48%',
                        stack: [
                            {
                                table: {
                                    widths: ['42%', '2%', '56%'],
                                    body: [
                                        [
                                            { text: 'Company Name', border: [false, false, false, false], fontSize: 9 },
                                            { text: ':', border: [false, false, false, false], fontSize: 9 },
                                            { text: (selectedPurchase?.wareHouseDetails.map(v => v.wareHouseName)) || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                        ],
                                        [
                                            { text: 'Address', border: [false, false, false, false], fontSize: 9 },
                                            { text: ':', border: [false, false, false, false], fontSize: 9 },
                                            { text: (selectedPurchase?.wareHouseDetails.map(v => v.address)) || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                        ],
                                        [
                                            { text: 'Contact Person', border: [false, false, false, false], fontSize: 9 },
                                            { text: ':', border: [false, false, false, false], fontSize: 9 },
                                            { text: (selectedPurchase?.wareHouseDetails.map(v => v.contactPersonName)) || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                        ],
                                        [
                                            { text: 'Contact No', border: [false, false, false, false], fontSize: 9 },
                                            { text: ':', border: [false, false, false, false], fontSize: 9 },
                                            { text: (selectedPurchase?.wareHouseDetails.map(v => v.contactNumber)) || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                        ]
                                    ]
                                },
                                layout: {
                                    defaultBorder: false,
                                    paddingLeft: function (i) { return 4; },
                                    paddingRight: function (i) { return 4; },
                                    paddingTop: function (i) { return 4; },
                                    paddingBottom: function (i) { return 4; }
                                }
                            }
                        ]
                    }
                ]
            },

            {
                table: {
                    headerRows: 1,
                    dontBreakRows: true,   // 🔥 IMPORTANT
                    keepWithHeaderRows: 1,
                    widths: ['auto', '*', '*', 'auto', 'auto', '*', 'auto', 'auto', 'auto'],
                    body: [
                        [
                            { text: 'SR. NO.', style: 'tableHeader', border: [true, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                            { text: 'PRODUCT NAME', style: 'tableHeader', border: [false, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                            { text: 'DESCRIPTION', style: 'tableHeader', border: [false, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                            { text: 'HSN CODE', style: 'tableHeader', border: [false, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                            { text: 'QTY.', style: 'tableHeader', border: [false, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                            { text: 'DESCRIPTION', style: 'tableHeader', border: [false, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                            { text: 'QTY', style: 'tableHeader', border: [false, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                            { text: 'UNIT PRICE', style: 'tableHeader', border: [false, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                            { text: 'TOTAL', style: 'tableHeader', border: [false, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size

                        ],
                        ...generateProductRows(selectedPurchase?.productData)
                    ],
                    layout: {
                        hLineWidth: function (i, node) {
                            if (i === node.table.body.length) return 0;
                            return 0.5;
                        },
                        vLineWidth: function () {
                            return 0.5;
                        }
                    }
                },
                margin: [0, 10, 0, 0] // Reduced table margin
            },
            {
                columns: [
                    { width: '*', text: '' }, // empty space (pushes content right)

                    {
                        width: '40%', // adjust width as needed
                        table: {
                            widths: ['60%', '40%'],
                            headerRows: 1,
                            dontBreakRows: true,   // 🔥 IMPORTANT
                            keepWithHeaderRows: 1,
                            body: [
                                [
                                    { text: 'Taxable Amount :', bold: true, fontSize: 10 },
                                    {
                                        text: `Rs. ${formatCurrency(selectedPurchase?.taxableAmount)}`,
                                        alignment: 'right',
                                        bold: true,
                                        fontSize: 10
                                    }
                                ],
                                [
                                    { text: 'Total GST Amount :', bold: true, fontSize: 10 },
                                    {
                                        text: `Rs. ${formatCurrency(selectedPurchase?.totalGstAmount)}`,
                                        alignment: 'right',
                                        bold: true,
                                        fontSize: 10
                                    }
                                ],
                                [
                                    { text: 'TOTAL :', bold: true, fontSize: 10 },
                                    {
                                        text: `Rs. ${formatCurrency(selectedPurchase?.amountTotal)}`,
                                        alignment: 'right',
                                        bold: true,
                                        fontSize: 10
                                    }
                                ]
                            ]
                        },

                    }
                ],
                margin: [0, 20, 0, 0]
            },
            {
                width: '*',
                stack: [
                    {
                        image: stampImg,
                        width: 100,
                        alignment: 'right'
                    },
                    {
                        text: 'Company Stamp & Sign',
                        alignment: 'right',
                        bold: true,
                        fontSize: 10,
                        margin: [0, 5, 0, 0]
                    }
                ],
                margin: [0, 20, 0, 0] // Reduced stamp margin
            }
        );

        const docDefinition = {
            content: allPagesContent,
            styles: {
                header: {
                    fontSize: 25,
                    bold: true,
                    color: '#1F2F58',
                    font: 'Lexend',
                },
                subheader: {
                    fontSize: 20,
                    bold: true,
                    margin: [0, 10, 0, 5],
                    font: 'Lexend',
                },
                tableHeader: {
                    bold: true,
                    color: 'white',
                    fillColor: '#293754',
                    font: 'Lexend',
                }
            },
            defaultStyle: {
                fontSize: 12,
                font: 'Lexend',
            }
        };


        return docDefinition;
    };

    const downloadPDF = async () => {
        await getLexendFonts();



        if ([].length > 0) {
            const allContent = [];

            for (const process of []) {
                const marketData = [].find(m => m._id === process.marketId);
                const fData = [];




                const docDefinition = await generatePdfContent();
                allContent.push(...docDefinition.content);

                // if (process !== selectedDispatchProcess[selectedDispatchProcess.length - 1]) {
                //     allContent.push({ text: '', pageBreak: 'before' });
                // }
            }




            const finalDocDefinition = {
                content: allContent,
                defaultStyle: {
                    font: 'Lexend',
                },
                styles: {
                    header: {
                        fontSize: 25,
                        bold: true,
                        color: '#1F2F58',
                        font: 'Lexend',
                    },
                    sectionHeader: {
                        fontSize: 16,
                        bold: true,
                        color: 'white',
                        fillColor: '#293754',
                        padding: 8,
                        font: 'Lexend',
                    },
                    tableHeader: {
                        bold: true,
                        color: 'white',
                        fillColor: '#293754',
                        font: 'Lexend',
                    }
                },
                defaultStyle: {
                    fontSize: 12
                }
            };
            const pdfFilename = `${(selectedPurchase?.vendorDetails)?.map(v => v.businessName).join('_') || 'N/A'}_${selectedPurchase?.PurchaseDate ? format(new Date(selectedPurchase.PurchaseDate), 'dd-MM-yyyy') : 'N/A'}_${selectedPurchase?.SrNo ? selectedPurchase.SrNo.slice(-4) : 'N/A'}.pdf`;

            pdfMake.createPdf(finalDocDefinition).download(pdfFilename);
        } else {
            const matchingDispatchProcess = []



            const fData = []


            const docDefinition = await generatePdfContent();

            const pdfFilename = `${(selectedPurchase?.vendorDetails)?.map(v => v.businessName).join('_') || 'N/A'}_${selectedPurchase?.PurchaseDate ? format(new Date(selectedPurchase.PurchaseDate), 'dd-MM-yyyy') : 'N/A'}_${selectedPurchase?.SrNo ? selectedPurchase.SrNo.slice(-4) : 'N/A'}.pdf`;
            pdfMake.createPdf(docDefinition).download(pdfFilename);
        }
    };
    const getStatusFromPercentage = (paymentPercentage, materialPercentage) => {
        return paymentPercentage >= 100 && materialPercentage >= 100 ? 'Complete' : 'Pending';
    };

    const isStoreComplete = (storeEntry) => {


        if (!storeEntry) return false;
        return storeEntry.multipleQty.every(item =>
            Number(item.recieveQtyforstore) >= Number(item.TotalQty)
        );
    };

    const x = purchase.filter(v => v.SrNo === "TEL/2025-26/0019").filter(v => {
        const paymentPercentage = ((Number(v.venderPayments?.find(d => d.VendorpurchaseId === v._id)?.VendorPaymentDetails.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0) * 100) / v.amountTotal || 0;
        const materialPercentage = (v.purchaseDetails?.reduce((acc, curr) => acc + curr.multipleQty.reduce((sum, item) => sum + Number(item.recieveQtyforstore), 0), 0) * 100) / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1);




        return Math.round(paymentPercentage) < 100 || materialPercentage < 100;
    });




    return (
        <Box m="2px" sx={{ overflow: isMobileee ? 'auto' : 'hidden', }}>
            <Header
                title="PURCHASE"
                subtitle="Manage Your Purchase Here"
            />


            <Box
                sx={{ display: { xs: "block", md: "flex" }, justifyContent: "space-between", marginTop: "20px" }}
            >
                <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    sx={{
                        minWidth: '100%', // Default to 100%
                        [theme.breakpoints.up('sm')]: {
                            minWidth: '300px', // 200px for screens >= 600px
                        },
                        [theme.breakpoints.down('sm')]: {
                            minWidth: '100%', // 100% for screens < 600px
                        },
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: '#566585',
                            },
                            '&:hover fieldset': {
                                borderColor: '#566585',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#566585',
                                borderWidth: '2px',
                            },
                        },
                        mb: { xs: 2 },
                    }}
                />
                <FormControl size="small" sx={{ mr: 2 }}>
                    <Select
                        value={statusFilter}
                        onChange={handleStatusChange}
                        sx={{
                            minWidth: '200px',
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#566585',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#566585',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#566585',
                                borderWidth: '2px',
                            },
                        }}
                    >
                        <MenuItem value="all">All Status ({purchase.length})</MenuItem>
                        <MenuItem value="pending">
                            Pending ({purchase.filter(v => {
                                const paymentPercentage = ((Number(v.venderPayments?.find(d => d.VendorpurchaseId === v._id)?.VendorPaymentDetails.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0) * 100) / v.amountTotal || 0;
                                const materialPercentage = (v.purchaseDetails?.reduce((acc, curr) => acc + curr.multipleQty.reduce((sum, item) => sum + Number(item.recieveQtyforstore), 0), 0) * 100) / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1);
                                return Math.round(paymentPercentage) < 100 || materialPercentage < 100;
                            }).length})
                        </MenuItem>
                        <MenuItem value="complete">
                            Complete ({purchase.filter(v => {
                                const paymentPercentage = ((Number(v.venderPayments?.find(d => d.VendorpurchaseId === v._id)?.VendorPaymentDetails.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0) * 100) / v.amountTotal || 0;
                                const materialPercentage = (v.purchaseDetails?.reduce((acc, curr) => acc + curr.multipleQty.reduce((sum, item) => sum + Number(item.recieveQtyforstore), 0), 0) * 100) / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1);
                                return Math.round(paymentPercentage) >= 100 && materialPercentage >= 100;
                            }).length})
                        </MenuItem>
                    </Select>
                </FormControl>
            </Box>

            <Box display="flex" justifyContent="flex-end" mb={2}>
                <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleAddMarketing}>
                    Add Purchase
                </Button>
            </Box>
            {filteredPurchases?.length > 0 ? (
                filteredPurchases?.map((v) => {
                    const completedSteps = getCompletedSteps(v);
                    const relatedStoreEntries = v.purchaseDetails?.filter(s => s.purchase === v._id);
                    const totalReceivedQty = relatedStoreEntries?.reduce((acc, curr) => {
                        return acc + curr.multipleQty.reduce((sum, item) => sum + item.recieveQtyforstore, 0);
                    }, 0);
                    return (
                        <Box className="padding_box" sx={{
                            m: 3, ml: 0, mr: 0, p: 3, borderRadius: 2, bgcolor: theme.palette.mode === 'dark' ? '#293040' : "#E5F1FD", color: theme.palette.mode === 'dark' ? 'white' : "black",
                            overflowX: 'auto',
                        }} key={v._id}
                        >
                            <Grid container item>
                                {!isMobile && (
                                    <Grid item sx={{ flexGrow: 1 }}>
                                        {/* <Typography sx={{ whiteSpace: 'pre-line', display: 'flex' }}> */}
                                        <Box sx={{ whiteSpace: 'pre-line', display: 'flex', flexGrow: 1 }}>
                                            <Box sx={{ width: '280px' }}>
                                                <ul>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Date</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Purchase Order Number</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>PO Value</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Vendor</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Ship To</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Payment Against PO</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Material Recived Against Invoice</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Store upload file</li>
                                                </ul>
                                            </Box>
                                            <Box sx={{ width: '300px' }}>
                                                <ul>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {v.PurchaseDate ? format(new Date(v.PurchaseDate), 'dd-MM-yyyy') : 'N/A'}
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;{v.SrNo}</li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {v.amountTotal % 1 === 0 ? `${v.amountTotal.toFixed(0)}` : `${v.amountTotal.toFixed(3)}`}
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {
                                                            (v.vendorDetails?.map(v => v.businessName))
                                                        }
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {
                                                            (v.wareHouseDetails?.map(v => v.wareHouseName))
                                                        }
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {
                                                            (() => {
                                                                const percentage = ((Number(v.venderPayments?.[0]?.VendorPaymentDetails.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0) * 100) / v.amountTotal || 0;
                                                                return percentage % 1 === 0 ? `${percentage.toFixed(0)}%` : `${percentage.toFixed(2)}%`;
                                                            })()
                                                        }
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {((totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)) % 1 === 0)
                                                            ? `${(totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)).toFixed(0)}%`
                                                            : `${(totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)).toFixed(2)}%`
                                                        }
                                                    </li>
                                                    <li style={{ listStyleType: 'none', cursor: 'pointer' }}> &nbsp;
                                                        {
                                                            <RemoveRedEyeIcon
                                                                // onClick={() => setstoreFile(true)}
                                                                onClick={() => handlestore(v._id)}
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        }
                                                    </li>
                                                </ul>
                                            </Box>
                                            <Box sx={{ flexGrow: 1 }}>
                                                <Grid sx={{ textAlign: 'start', marginBottom: 2, display: 'flex', alignItems: 'center', justifyContent: "flex-end", flexGrow: 1, flexWrap: "nowrap" }}>
                                                    <IconButton
                                                        sx={{
                                                            backgroundColor: (() => {
                                                                const paymentPercentage = ((Number(v.venderPayments?.find(d => d.VendorpurchaseId === v._id)?.VendorPaymentDetails.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0) * 100) / v.amountTotal || 0;
                                                                const materialPercentage = (totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1));
                                                                return Math.round(paymentPercentage) >= 100 && materialPercentage >= 100 ? '#2c742c' : '#9b2323';
                                                            })(),
                                                            '&:hover': {
                                                                backgroundColor: (() => {
                                                                    const paymentPercentage = ((Number(v.venderPayments?.find(d => d.VendorpurchaseId === v._id)?.VendorPaymentDetails.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0) * 100) / v.amountTotal || 0;
                                                                    const materialPercentage = (totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1));
                                                                    return Math.round(paymentPercentage) >= 100 && materialPercentage >= 100 ? '#2c742c' : '#9b2323';
                                                                })(),
                                                            },
                                                            mr: 2,
                                                            padding: "8px 12px",
                                                            borderRadius: '4px'
                                                        }}
                                                    >
                                                        <Typography sx={{ color: 'white' }}>
                                                            {(() => {
                                                                const paymentPercentage = ((Number(v.venderPayments?.find(d => d.VendorpurchaseId === v._id)?.VendorPaymentDetails.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0) * 100) / v.amountTotal || 0;
                                                                const materialPercentage = (totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1));
                                                                return Math.round(paymentPercentage) >= 100 && materialPercentage >= 100 ? 'Complete' : 'Pending';
                                                            })()}
                                                        </Typography>
                                                    </IconButton>
                                                    <IconButton aria-label="print" style={{ color: "white", backgroundColor: "#134670" }} sx={{ mr: 2, bgcolor: '#134670', padding: "10px" }}
                                                        onClick={() => handlePrint(v._id)}>
                                                        <PrintIcon />
                                                    </IconButton>
                                                    <IconButton
                                                        aria-label="edit"
                                                        disabled={isStoreComplete(store.find(s => s.purchase === v._id))}
                                                        style={{
                                                            color: "white",
                                                            backgroundColor: isStoreComplete(store.find(s => s.purchase === v._id)) ? "gray" : "#134670"
                                                        }}
                                                        sx={{ mr: 2, bgcolor: '#134670', padding: "10px" }}
                                                        onClick={() => handleEdit(v._id)}
                                                    >
                                                        <EditIcon />
                                                    </IconButton>

                                                    {
                                                        ! isStoreComplete(store.find(s => s.purchase === v._id)) &&
                                                        <IconButton aria-label="delete" style={{ color: "white", backgroundColor: "#134670" }} sx={{ mr: 2, bgcolor: '#134670', padding: "10px" }} onClick={() => handleDelete(v._id)}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    }

                                                </Grid>
                                            </Box>
                                        </Box>
                                    </Grid>
                                )}

                                {isMobile ? (
                                    <>
                                        <Grid item sx={{ flexGrow: 1 }}>
                                            {/* <Typography sx={{ whiteSpace: 'pre-line', display: 'flex' }}> */}
                                            <Box sx={{ whiteSpace: 'pre-line', display: 'flex', flexGrow: 1 }}>
                                                <Box sx={{ width: '280px' }}>
                                                    <ul>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Date</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Purchase Order Number</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>PO Value</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Vendor</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Ship To</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Payment Against PO</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Material Recived Against Invoice</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Store upload file</li>
                                                    </ul>
                                                </Box>
                                                <Box sx={{ width: '300px' }}>
                                                    <ul>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {v.PurchaseDate ? format(new Date(v.PurchaseDate), 'dd-MM-yyyy') : 'N/A'}
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;{v.SrNo}</li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {v.amountTotal}
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {
                                                                (v.vendorDetails?.map(v => v.businessName))
                                                            }
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {
                                                                (v.wareHouseDetails?.map(v => v.wareHouseName))
                                                            }
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {
                                                                (() => {
                                                                    const percentage = ((Number(v.venderPayments?.find(d => d.VendorpurchaseId == v._id)?.VendorPaymentDetails.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0) * 100) / v.amountTotal || 0;
                                                                    return percentage % 1 === 0 ? `${percentage.toFixed(0)}%` : `${percentage.toFixed(2)}%`;
                                                                })()
                                                            }
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {((totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)) % 1 === 0)
                                                                ? `${(totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)).toFixed(0)}%`
                                                                : `${(totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)).toFixed(2)}%`
                                                            }
                                                        </li>
                                                        <li style={{ listStyleType: 'none', cursor: 'pointer' }}> &nbsp;
                                                            {
                                                                <RemoveRedEyeIcon
                                                                    // onClick={() => setstoreFile(true)}
                                                                    onClick={() => handlestore(v._id)}
                                                                    style={{ cursor: 'pointer' }}
                                                                />
                                                            }
                                                        </li>
                                                    </ul>
                                                </Box>
                                                <Box sx={{ flexGrow: 1 }}>
                                                    <Grid sx={{ textAlign: 'start', marginBottom: 2, display: 'flex', alignItems: 'center', justifyContent: "flex-end", flexGrow: 1, flexWrap: "nowrap" }}>
                                                        <IconButton
                                                            sx={{
                                                                backgroundColor: (() => {
                                                                    const paymentPercentage = ((Number(v.venderPayments?.find(d => d.VendorpurchaseId === v._id)?.VendorPaymentDetails.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0) * 100) / v.amountTotal || 0;
                                                                    const materialPercentage = (totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1));
                                                                    return Math.round(paymentPercentage) >= 100 && materialPercentage >= 100 ? '#2c742c' : '#9b2323';
                                                                })(),
                                                                '&:hover': {
                                                                    backgroundColor: (() => {
                                                                        const paymentPercentage = ((Number(v.venderPayments?.find(d => d.VendorpurchaseId === v._id)?.VendorPaymentDetails.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0) * 100) / v.amountTotal || 0;
                                                                        const materialPercentage = (totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1));
                                                                        return Math.round(paymentPercentage) >= 100 && materialPercentage >= 100 ? '#2c742c' : '#9b2323';
                                                                    })(),
                                                                },
                                                                mr: 2,
                                                                padding: "8px 12px",
                                                                borderRadius: '4px'
                                                            }}
                                                        >
                                                            <Typography sx={{ color: 'white' }}>
                                                                {(() => {
                                                                    const paymentPercentage = ((Number(v.venderPayments?.find(d => d.VendorpurchaseId === v._id)?.VendorPaymentDetails.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0) * 100) / v.amountTotal || 0;
                                                                    const materialPercentage = (totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1));
                                                                    return Math.round(paymentPercentage) >= 100 && materialPercentage >= 100 ? 'Complete' : 'Pending';
                                                                })()}
                                                            </Typography>
                                                        </IconButton>
                                                        <IconButton aria-label="print" style={{ color: "white", backgroundColor: "#134670" }} sx={{ mr: 2, bgcolor: '#134670', padding: "10px" }}
                                                            onClick={() => handlePrint(v._id)}>
                                                            <PrintIcon />
                                                        </IconButton>
                                                        <IconButton
                                                            disabled={isStoreComplete(store.find(s => s.purchase === v._id))}
                                                            style={{
                                                                color: "white",
                                                                backgroundColor: isStoreComplete(store.find(s => s.purchase === v._id)) ? "gray" : "#134670"
                                                            }}
                                                            aria-label="edit"
                                                            onClick={() => handleEdit(v._id)}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                        <IconButton aria-label="delete" style={{ color: "white", backgroundColor: "#134670" }} sx={{ mr: 2, bgcolor: '#134670', padding: "10px" }} onClick={() => handleDelete(v._id)}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Grid>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </>
                                ) : (
                                    <>

                                    </>
                                )}
                            </Grid>

                            {isMobile ? (
                                <MobileStepper
                                    steps={steps}
                                    activeStep={activeStep}
                                    completedSteps={completedSteps}
                                />
                            ) : (
                                <Stepper
                                    className='round_r'
                                    sx={{ mt: 3 }}
                                    alternativeLabel
                                    connector={<ColorlibConnector />}
                                >
                                    {steps.map((label, index) => {
                                        const stepNumber = index + 1;
                                        const isStepCompleted = completedSteps[stepNumber];
                                        return (
                                            <Step key={label} completed={isStepCompleted}>
                                                <StepLabel
                                                    StepIconComponent={ColorlibStepIcon}
                                                    StepIconProps={{
                                                        completed: isStepCompleted
                                                    }}
                                                >
                                                    <Typography style={{
                                                        color: isStepCompleted ? theme.palette.mode === 'dark' ? '#6da2cd' : "#165e99" : theme.palette.text.primary,
                                                        fontWeight: '600'
                                                    }}>
                                                        {label}
                                                    </Typography>
                                                </StepLabel>
                                            </Step>
                                        );
                                    })}
                                </Stepper>
                            )}
                        </Box >

                    )
                })
            ) : (
                <Box>
                    <Typography variant="h5" color="textSecondary" align="center">
                        No Results Found. Please Try a Different Search Term.
                    </Typography>
                </Box>
            )}
            <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="md">
                <DialogContent>
                    <Box sx={{ padding: 2 }} ref={printRef}>
                        <Grid container justifyContent="space-between" alignItems="center" sx={{ marginBottom: 4 }}>
                            <Grid item>
                                <Box
                                    component="img"
                                    className='pdf-logo'
                                    src={(theme.palette.mode === "dark" ? '../../assets/images/logo/dark-logo.png' : '../../assets/images/logo/logo.svg')}
                                    alt="Tvarit Energy LLP Logo"
                                    sx={{ width: 150 }}
                                />
                            </Grid>
                            <Grid item>
                                <Box sx={{ borderBottom: '2px solid #FB9822', marginBottom: 2 }}>
                                    <Typography
                                        variant="h5"
                                        className="purchase-order-title"
                                        sx={{
                                            fontWeight: 'bold',
                                            fontSize: '25px',
                                            letterSpacing: '5px',
                                            textAlign: 'right',
                                            color: theme.palette.mode === "dark" ? 'white' : '#1F2F58',
                                            position: 'relative',
                                            paddingBottom: '4px'
                                        }}
                                    >

                                        PURCHASE ORDER
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} sx={{
                            display: 'flex',
                            alignItems: 'center',
                            height: '100%'
                        }}>
                            <Grid item xs={6}>
                                <Box sx={{ backgroundColor: '#293754', color: 'white', padding: 1 }}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '16px', letterSpacing: '3px' }}>BILL TO</Typography>
                                </Box>
                                <Grid container direction="column" spacing={1} sx={{ marginTop: '10px' }}>
                                    <Grid item container>
                                        <Grid item xs={4}><Typography sx={{ fontWeight: '700' }}>Company Name</Typography></Grid>
                                        <Grid item xs={1}><Typography sx={{ fontWeight: '700' }}>:</Typography></Grid>
                                        <Grid item xs={7}><Typography sx={{ fontWeight: '700' }}>{orderDetails.billTo.companyName}</Typography></Grid>
                                    </Grid>
                                    <Grid item container>
                                        <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Address</Typography></Grid>
                                        <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                        <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{orderDetails.billTo.address}</Typography></Grid>
                                    </Grid>
                                    <Grid item container>
                                        <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>GST No</Typography></Grid>
                                        <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                        <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{orderDetails.billTo.gst}</Typography></Grid>
                                    </Grid>
                                    <Grid item container>
                                        <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Contact No</Typography></Grid>
                                        <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                        <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{orderDetails.billTo.contactNumber}</Typography></Grid>
                                    </Grid>
                                    <Grid item container>
                                        <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Email</Typography></Grid>
                                        <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                        <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{orderDetails.billTo.email}</Typography></Grid>
                                    </Grid>
                                    <Grid item container>
                                        <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Website</Typography></Grid>
                                        <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                        <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{orderDetails.billTo.website}</Typography></Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={6} sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '100%'
                            }}>
                                <Grid item container>
                                    <Grid item xs={4} sx={{ textAlign: 'right' }}><Typography sx={{ fontWeight: '600' }}>Date&nbsp;&nbsp;:&nbsp;&nbsp;</Typography></Grid>
                                    <Grid item xs={7}>
                                        <Typography sx={{ fontWeight: '600' }}>
                                            {selectedPurchase?.PurchaseDate ? format(new Date(selectedPurchase.PurchaseDate), 'dd-MM-yyyy') : 'N/A'}
                                        </Typography>
                                    </Grid>
                                </Grid>

                                <Grid item container>
                                    <Grid item xs={4} sx={{ textAlign: 'right' }}><Typography sx={{ fontWeight: '600' }}>PO #&nbsp;&nbsp;:&nbsp;&nbsp;</Typography></Grid>
                                    <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}> {selectedPurchase?.SrNo || 'N/A'}</Typography></Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ marginTop: 2 }}>
                            <Grid item xs={6}>
                                <Box sx={{ backgroundColor: '#293754', color: 'white', padding: 1 }}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '16px', letterSpacing: '3px' }}>VENDOR</Typography>
                                </Box>

                                <Box sx={{ marginTop: '10px', wordSpacing: '2px' }}>
                                    <Grid container direction="column" spacing={1}>
                                        <Grid item container>
                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Company Name</Typography></Grid>
                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{(selectedPurchase?.vendorDetails)?.map(v => v.businessName) || 'N/A'}</Typography></Grid>
                                        </Grid>
                                        <Grid item container>
                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Address</Typography></Grid>
                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{(selectedPurchase?.vendorDetails)?.map(v => v.officeAddress) || 'N/A'}</Typography></Grid>
                                        </Grid>
                                        <Grid item container>
                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Contact Person</Typography></Grid>
                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{selectedPurchase?.vendorDetails?.map(v => v.contactPersonalDetails?.map(v => v.contactPersonName)).join(', ') || 'N/A'}</Typography></Grid>
                                        </Grid>
                                        <Grid item container>
                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Contact No</Typography></Grid>
                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{selectedPurchase?.vendorDetails?.map(v => v.contactPersonalDetails?.map(v => v.contactNumber)).join(', ') || 'N/A'}</Typography></Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box sx={{ backgroundColor: '#293754', color: 'white', padding: 1 }}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '16px', letterSpacing: '3px' }}>SHIP TO</Typography>
                                </Box>
                                <Box sx={{ marginTop: '10px', wordSpacing: '2px' }} >
                                    <Grid container direction="column" spacing={1}>
                                        <Grid item container>
                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Company Name</Typography></Grid>
                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{(selectedPurchase?.wareHouseDetails.map(v => v.wareHouseName)) || 'N/A'}</Typography></Grid>
                                        </Grid>
                                        <Grid item container>
                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Address</Typography></Grid>
                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{(selectedPurchase?.wareHouseDetails.map(v => v.address)) || 'N/A'}</Typography></Grid>
                                        </Grid>
                                        <Grid item container>
                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Contact Person</Typography></Grid>
                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{(selectedPurchase?.wareHouseDetails.map(v => v.contactPersonName)) || 'N/A'}</Typography></Grid>
                                        </Grid>
                                        <Grid item container>
                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Contact No</Typography></Grid>
                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{(selectedPurchase?.wareHouseDetails.map(v => v.contactNumber)) || 'N/A'}</Typography></Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>
                        <TableContainer sx={{ marginTop: 2 }}>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#293754' }}>
                                    <TableRow>
                                        <TableCell sx={{ color: 'white' }}>SR. NO.</TableCell>
                                        <TableCell sx={{ color: 'white' }}>PRODUCT NAME</TableCell>
                                        <TableCell sx={{ color: 'white' }}>DESCRIPTION</TableCell>
                                        <TableCell sx={{ color: 'white' }}>HSN CODE</TableCell>
                                        <TableCell sx={{ color: 'white' }}>QTY.</TableCell>
                                        <TableCell sx={{ color: 'white' }}>UNIT PRICE</TableCell>
                                        <TableCell sx={{ color: 'white' }}>TOTAL</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {selectedPurchase?.productData?.map((item, index) => {
                                        const ShowDesacription = selectedPurchase?.multipledata?.find(p => p.productName === item._id).description;
                                        const matchedItem = selectedPurchase?.multipledata?.find(p => p.productName === item._id);
                                        return (
                                            <TableRow key={index}>
                                                <TableCell sx={{ fontWeight: '600' }}>{index + 1}</TableCell>
                                                <TableCell sx={{ fontWeight: '600' }}>{item?.productName || 'N/A'}</TableCell>
                                                <TableCell sx={{ fontWeight: '600' }}>{ShowDesacription || 'N/A'}</TableCell>
                                                <TableCell sx={{ fontWeight: '600' }}>{item?.HSNcode || 'N/A'}</TableCell>
                                                <TableCell sx={{ fontWeight: '600' }}>{matchedItem?.Qty || 'N/A'}</TableCell>
                                                <TableCell sx={{ fontWeight: '600' }}>Rs. {matchedItem?.unitPrice || 'N/A'}</TableCell>
                                                <TableCell sx={{ fontWeight: '600', textWrap: 'nowrap' }}>Rs. {matchedItem?.Qty * matchedItem?.unitPrice}</TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Grid container justifyContent="space-between" sx={{ marginTop: 2 }}>
                            <Grid item xs={6}>
                                <Typography variant="body1" sx={{ marginBottom: '10px', fontWeight: '700' }}>Comment or Special Instructions:</Typography>
                                <Grid container>
                                    {selectedPurchase?.termsDetails && selectedPurchase.termsDetails.length > 0 ? (
                                        selectedPurchase.termsDetails.map((term, index) => (
                                            <Grid item xs={12} key={index} sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <Grid container>
                                                    <Grid item xs={1}>
                                                        <Typography variant="body2">
                                                            <span style={{ fontSize: '20px', lineHeight: '0' }}>•</span>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Typography variant="body2" sx={{
                                                            fontWeight: '600',
                                                            wordBreak: 'break-word',
                                                            overflowWrap: 'break-word'
                                                        }}>
                                                            {(term)?.name || 'N/A'}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={1}>
                                                        <Typography variant="body2" sx={{
                                                            fontWeight: '600',
                                                            wordBreak: 'break-word',
                                                            overflowWrap: 'break-word'
                                                        }}> :
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={8}>
                                                        <Typography variant="body2" sx={{
                                                            fontWeight: '600',
                                                            wordBreak: 'break-word',
                                                            overflowWrap: 'break-word'
                                                        }}>
                                                            {(term)?.description || ''}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        ))
                                    ) : (
                                        <Grid item xs={12}>
                                            <Typography variant="body2" sx={{ fontWeight: '600' }}><strong>-</strong></Typography>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid item xs={6} md={4}>
                                <TableContainer>
                                    <Table sx={{ '& td, & th': { border: '1px solid #1A2B4F' } }}>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: '600' }}><strong>Taxable Amount :</strong></TableCell>
                                                <TableCell align="right" sx={{ fontWeight: '600' }}>Rs. {formatCurrency(selectedPurchase?.taxableAmount)}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: '600' }}><strong>Total GST Amount :</strong></TableCell>
                                                <TableCell align="right" sx={{ fontWeight: '600' }}>Rs. {formatCurrency(selectedPurchase?.totalGstAmount)}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: '700' }}><strong>TOTAL :</strong></TableCell>
                                                <TableCell align="right" sx={{ fontWeight: '700' }}><strong>Rs. {formatCurrency(selectedPurchase?.amountTotal)}</strong></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>

                        <Grid container justifyContent="flex-end" sx={{ marginTop: -2 }}>
                            <Grid item>
                                <Box
                                    component="img"
                                    className='stamp-sign'
                                    src={'../../assets/images/stamp/stamp-1.svg'}
                                    alt="Tvarit Energy LLP stamp"
                                    sx={{ width: 150 }}
                                />
                                <Typography variant="body1" sx={{ fontWeight: '600' }}>Company Stamp & Sign</Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={downloadPDF} sx={{ color: theme.palette.text.primary }}>Download PDF</Button>
                    <Button onClick={handleCloseDialog} sx={{ color: theme.palette.text.primary }}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={storeFile}
                onClose={handleCloseDialog}
                fullWidth
                maxWidth="md"
            >
                <DialogContent>
                    <Typography variant="h6" fontWeight={700} sx={{ mb: 2, textAlign: 'center' }}>Store Upload Files</Typography>

                    {selectedPurchase?.purchaseDetails?.length > 0 ? (
                        selectedPurchase.purchaseDetails.map((file, index) => (
                            <Box key={index} sx={{ mb: 2, textAlign: 'center' }}>
                                {file.storeuploadFile?.toLowerCase().endsWith('.pdf') ? (
                                    <iframe
                                        src={`${imgUrl}/${file.storeuploadFile}`}
                                        style={{ width: '800px', height: '80vh', border: 'none' }}
                                        title={`Store File`}
                                    />
                                ) : (
                                    <img
                                        style={{ width: '700px', height: '80vh', objectFit: 'contain' }}
                                        src={`${imgUrl}/${file.storeuploadFile}`}
                                        alt={`Store Image`}
                                    />
                                )}
                            </Box>
                        ))
                    ) : (
                        <Typography>No store files uploaded yet.</Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} sx={{ color: theme.palette.text.primary }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteConfirmOpen} onClose={cancelDelete}>
                <DialogContent>
                    Are you sure you want to delete this Purchase?
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancelDelete} style={{ color: theme.palette.text.primary }}>No</Button>
                    <Button onClick={confirmDelete} style={{ color: theme.palette.text.primary }}>Yes</Button>
                </DialogActions>
            </Dialog>
        </Box >
    );
};

export default ListPurchase;